<template>
  <div>
    <div id="bg" class="container">
      <video
        v-show="pc"
        id="deo"
        class="video1"
        :style="'width:'+videoW+';height:'+videoH+';'"
        src="@/assets/video/bg3.mp4"
        type="video/mp4"
        autoplay="true"
        loop="true"
        muted="true"
      ></video>
    </div>
    <div v-show="!pc">
      <transition
        @before-enter="beforeEnter"
        @enter="enter"
        @leave="leave"
        @after-enter="afterEnter"
        @after-leave="afterLeave"
        mode="in-out"
        @css="false"
      >
        <img v-if="!pc&&imgbg.bg1" src="@/assets/img/app_bg1.jpg" class="img" id="i1">
      </transition>
      <transition
        @before-enter="beforeEnter"
        @enter="enter"
        @leave="leave"
        @after-enter="afterEnter"
        @after-leave="afterLeave"
        mode="in-out"
        @css="false"
      >
        <img v-if="!pc&&imgbg.bg2" src="@/assets/img/app_bg2.jpg" class="img" id="i2">
      </transition>
      <transition
        @before-enter="beforeEnter"
        @enter="enter"
        @leave="leave"
        @after-enter="afterEnter"
        @after-leave="afterLeave"
        mode="in-out"
        @css="false"
      >
        <img v-if="!pc&&imgbg.bg3" src="@/assets/img/app_bg3.jpg" class="img" id="i3">
      </transition>
      <transition
        @before-enter="beforeEnter"
        @enter="enter"
        @leave="leave"
        @after-enter="afterEnter"
        @after-leave="afterLeave"
        mode="in-out"
        @css="false"
      >
        <img v-if="!pc&&imgbg.bg4" src="@/assets/img/app_bg4.jpg" class="img" id="i4">
      </transition>
      <transition
        @before-enter="beforeEnter"
        @enter="enter"
        @leave="leave"
        @after-enter="afterEnter"
        @after-leave="afterLeave"
        mode="in-out"
        @css="false"
      >
        <img v-if="!pc&&imgbg.bg5" src="@/assets/img/app_bg5.jpg" class="img" id="i5">
      </transition>
      <transition
        @before-enter="beforeEnter"
        @enter="enter"
        @leave="leave"
        @after-enter="afterEnter"
        @after-leave="afterLeave"
        mode="in-out"
        @css="false"
      >
        <img v-if="!pc&&imgbg.bg6" src="@/assets/img/app_bg6.jpg" class="img" id="i6">
      </transition>
    </div>
  </div>
</template>

    <script>
/* eslint-disable */
export default {
  name: "bg",
  data() {
    return {
      videoW: "160px",
      videoH: "90px",
      pc: true,
      imgbg: {
        bg1: false,
        bg2: false,
        bg3: false,
        bg4: false,
        bg5: false,
        bg6: false
      },
      i: 1,
      tout: 0
    };
  },

  mounted() {
    // //初始化视频方法
    var that = this;
    window.onresize = () => {
      var windowWidth = document.body.clientWidth;
      var windowHeight = document.body.clientHeight;
      // console.log(windowWidth+","+windowHeight)
      var ratio = windowHeight / windowWidth;
      var countWidth = windowHeight / 0.562;
      var countHeight = windowWidth * 0.562;
      if (countWidth < windowWidth) {
        that.videoW = windowWidth + "px";
        that.videoH = windowWidth * 0.562 + "px";
      } else if (countHeight < windowHeight) {
        that.videoH = windowHeight + "px";
        that.videoW = windowHeight / 0.562 + "px";
      } else {
        that.videoH = windowHeight + "px";
        that.videoW = windowWidth + "px";
      }
      // console.log(that.videoW+","+that.videoH)

      // if(ratio<0.562){
      //     if(countWidth<windowWidth){
      //     that.videoH=windowWidth*0.562+"px"
      //     that.videoW=windowWidth+"px"
      //     }else{
      //       that.videoH = windowHeight+"px"
      //       that.videoW = windowHeight/0.562+"px"
      //     }
      // }else{
      //   if(countHeight<windowHeight){
      //     that.videoH=windowHeight+"px"
      //     that.videoW=windowHeight/0.562+"px"
      //     }else{
      //       that.videoH = windowWidth*0.562+"px"
      //       that.videoW = windowWidth+"px"
      //     }
      // }

      if (windowWidth > 750) {
        that.pc = true;
      } else {
        that.pc = false;
      }

      that.$emit("isPc", that.pc);
    };
    window.onresize();
    this.imgbg.bg1 = true;
    // this.imgbg["bg" + this.i] = true;
    // var fuc = () => {
    //   clearTimeout(this.tout);
    //   this.tout = setTimeout(() => {
    //     this.imgbg["bg" + this.i] = false;
    //     this.i++;
    //     if (this.i == 7) {
    //       this.i = 1;
    //     }
    //     this.imgbg["bg" + this.i] = true;

    //     if (this.pc == false) {
    //       console.log(this.imgbg);
    //       fuc();
    //     }
    //   }, 8000);
    // };
    // fuc();
  },
  watch: {
    // pc: function(data) {
    //   if (data == false) {
    //     this.imgbg["bg" + this.i] = true;
    //     var fuc = () => {
    //       clearTimeout(this.tout);
    //       this.tout = setTimeout(() => {
    //         this.imgbg["bg" + this.i] = false;
    //         this.i++;
    //         if (this.i == 7) {
    //           this.i = 1;
    //         }
    //         this.imgbg["bg" + this.i] = true;
    //         if (this.pc == false) {
    //           console.log(this.imgbg);
    //           fuc();
    //         }
    //       }, 8000);
    //     };
    //     fuc();
    //   }
    // }
  },
  methods: {
    beforeEnter(el) {
      el.style.opacity = 0;
      el.style.transition = "all ease"
    },
    enter(el, done) {
      switch (el.id) {
        case "i1":
          Velocity(el,{ opacity: 1, translateX: "20px", scale: 1.2, translateY: "8px" },{ duration: 5000 })
          Velocity(el,{ translateY: "-.2px" },{ duration: 2000 })
          break;
        case "i3":
          Velocity(el,{ opacity: 1, translateX: "-30px", scale: 1.2, translateY: "5px" },{ duration: 5000 })
          Velocity(el,{ translateX: "-2px" },{ duration: 2000 })
          break;
        case "i2":
          Velocity(el,{ opacity: 1, translateX: "10px", scale: 1.2, translateY: "-5px" },{ duration: 5000 })
          Velocity(el,{ translateY: "-.2px" },{ duration: 2000 })
          break;
          case "i4":
          Velocity(el,{ opacity: 1, translateX: "10px", scale: 1.2, translateY: "-5px" },{ duration: 5000 })
          Velocity(el,{ translateY: "-.2px" },{ duration: 2000 })
          break;
          case "i5":
          Velocity(el,{ opacity: 1, translateX: "5px", scale: 1.2, translateY: "-5px" },{ duration: 5000 })
          Velocity(el,{ translateY: "-.2px" },{ duration: 2000 })
          break;
          case "i6":
          Velocity(el,{ opacity: 1, translateX: "-5px", scale: 1.2, translateY: "5px" },{ duration: 5000 })
          Velocity(el,{ translateY: "-.2px" },{ duration: 2000 })
          break;
        default:
          break;
      }
      Velocity(el,{complete: done});
    },
    leave(el, done) {      
      Velocity(el, { opacity: 0}, { duration: 1000 });
      Velocity(el, { complete: done });

    },
    afterEnter(el) {
      switch (el.id) {
        case "i1":
          this.imgbg.bg1 = false;
          this.imgbg.bg2 = true;
          break;
        case "i2":
          this.imgbg.bg2 = false;
          this.imgbg.bg3 = true;
          break;
          case "i3":
          this.imgbg.bg3 = false;
          this.imgbg.bg4 = true;
          break;
          case "i4":
          this.imgbg.bg4 = false;
          this.imgbg.bg5 = true;
          break;
          case "i5":
          this.imgbg.bg5 = false;
          this.imgbg.bg6 = true;
          break;
          case "i6":
          this.imgbg.bg6 = false;
          this.imgbg.bg1 = true;
        break;
        default:
          break;
      }
    },
    afterLeave(el) {
      // console.log(el);
      // switch (el.id) {
      //   case "i1":
        
          
      //     break;
      //     case "i2":
      //     this.imgbg.bg3 = true;
      //     break;
      //     case "i3":
      //     this.imgbg.bg4 = true;
      //     break;
      //     case "i4":
      //     this.imgbg.bg5 = true;
      //     break;
      //     case "i5":
      //     this.imgbg.bg6 = true;
      //     break;
      //     case "i6":
      //     this.imgbg.bg1 = true;
      //     break;
      //   default:
      //     break;
      // }
    }
  }
};
</script>

<style scoped>
.container {
  display: flex;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: relative;
  /* background-color: green; */
}
.video1 {
  top: 0;
  left: 0;
}
.img {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
}
.fade-enter-active {
  transition: all ease;
}
.fade-leave-active {
  transition: all 1s ease;
}
.fade-enter {
  opacity: 0;
  transform: scale(1.5);
}

.fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/bg.vue